import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import PurchaseForm, {
  PurchaseFormData,
  PurchaseFormOptions,
} from "../../forms/PurchaseForm";
import CoreModal from "../CoreModal";
import { CoreEditModalProps } from "../ShipmentModals/EditShipmentModal";
import styles from "./styles.module.scss";

interface EditPurchaseModalProps
  extends CoreEditModalProps<PurchaseFormData, PurchaseFormOptions> {}

const EditPurchaseModal: React.FC<EditPurchaseModalProps> = ({
  data,
  open,
  onCancel,
  onBack,
  index,
  onPrev,
  onNext,
  options,
  onSaveData,
  filename,
}) => {
  const [draft, setDraft] = useState<PurchaseFormData>(data[index]);

  useEffect(() => setDraft(data[index]), [index, data]);

  const handleSave = () => onSaveData(draft, index);

  return (
    <CoreModal
      open={open}
      onCancel={onCancel}
      title={`Edit ${filename}`}
      onSave={handleSave}
      width={1000}
      maskClosable={false}
      backButton={onBack}
    >
      <div className={styles.navRow}>
        <span className={styles.counter}>
          {index + 1} of {data.length} entries
        </span>

        <div className={styles.navButtons}>
          <button
            type="button"
            className={styles.navBtn}
            disabled={index === 0}
            onClick={onPrev}
          >
            <LeftOutlined />
          </button>
          <button
            type="button"
            className={styles.navBtn}
            disabled={index === data.length - 1}
            onClick={onNext}
          >
            <RightOutlined />
          </button>
        </div>
      </div>

      <PurchaseForm data={draft} onChange={setDraft} options={options} />
    </CoreModal>
  );
};

export default EditPurchaseModal;
